import { loadMore } from "../utils/loadMore";
import { matchHeight } from "../utils/matchHeight";

function wineAcademyVintageLoadMore () {
  const producers = document.querySelector('.academy-vintage-scores.js-load-more-list')
  if (producers) loadMore(producers);
}

wineAcademyVintageLoadMore()

matchHeight(
  document.querySelectorAll('.academy-vintage-performance__score-item')
);
